import { CircleUserIcon } from "lucide-react";

type AIUserQueryProps = {
  content: string;
};

export function AIUserQuery({ content }: AIUserQueryProps) {
  content = content.trim();

  if (!content.length) {
    return null;
  }

  return (
    <div className="flex justify-end mb-8">
      <div className="flex gap-2">
        <div
          className="bg-secondary rounded-lg p-2 border"
          style={{
            maxWidth: "300px",
          }}
        >
          <p className="text-sm font-medium">{content}</p>
        </div>
        <div className="rounded-full size-6 bg-secondary border flex items-center justify-center">
          <CircleUserIcon className="size-4" />
        </div>
      </div>
    </div>
  );
}
